import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import {
  FaHome,
  FaList,
  FaCloudDownloadAlt,
  FaExclamationCircle,
  FaBars,
} from 'react-icons/fa'
import { TiUpload } from 'react-icons/ti'
import { MdHelp } from 'react-icons/md'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { Badge } from 'react-bootstrap'
import { SideNavItem } from 'components'
import brand from 'images/nspa_logo_wht2.png'
import { About, Header, Logo, Toogler, NavBar } from './style'
import { size } from 'utils/device'
import { Link } from 'raviger'
import { useWindowSize } from 'hooks/useWindowSize'
import { useProgramContext } from 'providers/programProvider'

const SideNav = ({ about, stagedCount }) => {
  const [width] = useWindowSize()
  const [state, dispatch] = useProgramContext()
  const stageCountWidget = stagedCount > 0 && (
    <Badge pill variant="warning" className="ml-2 small-font">
      {stagedCount}
    </Badge>
  )
  const items = [
    {
      text: 'Data Center Home',
      icon: <FaHome />,
      url: '/data-center',
    },
    {
      text: 'Your Programs',
      icon: <FaList />,
      url: '/data-center/programs',
    },
    {
      text: (
        <>
          Your Program Updates {stageCountWidget}
        </>
      ),
      icon: <><TiUpload />{!state.isOpen && stageCountWidget}</>,
      url: '/data-center/program-updates',
    },
    {
      text: 'Get Data',
      icon: <FaCloudDownloadAlt />,
      url: '/data-center/get-data',
    },
    {
      text: 'Help & Info',
      icon: <MdHelp />,
      url: '/data-center/help-info',
    },
  ]

  useEffect(() => {
    if (width && width < size.laptopM && state.isOpen) {
      tooggleMenu(false)
    } else if(state.isOpen === undefined) {
      //page loaded and it is a big screen
      tooggleMenu(true)
    }
  }, [width, state.isOpen])

  const tooggleMenu = (open) => dispatch({ type: 'MENU_TOGGLE', payload: open })

  return (
    <NavBar
      expand="xs"
      variant="dark"
      className={classnames('flex-column', { open: state.isOpen })}
    >
      <Header className="w-100 mb-4 pt-2">
        <Link href="/">
          <Logo src={brand} className="mt-4" />
        </Link>
        <Toogler
          onClick={() => tooggleMenu(!state.isOpen)}
          className={classnames({ 'mr-3': state.isOpen })}
        >
          {state.isOpen && <FiChevronLeft />}
          <FaBars />
          {!state.isOpen && <FiChevronRight />}
        </Toogler>
      </Header>

      {items.map((item, ix) => (
        <SideNavItem key={`nav-item-${ix}`} {...item} />
      ))}

      <About>
        <div>
          <FaExclamationCircle /> About this page
        </div>
        <p>{about}</p>
      </About>
    </NavBar>
  )
}

export default React.memo(SideNav)
